import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, Text } from "ui-components/Form";

function AdjustmentReasonInfo({ formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Adjustment Reason Information" : "Adjustment Reason Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };

              return (
                <Grid item xs={12} key={index}>
                  <Text field={fieldProps} />
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default AdjustmentReasonInfo;
